/**
  分拨路由配置
*/
import React from 'react';
import ParcelOrder from '@/pages/ParcelOrder';
import ParcelOrderDetail from '@/pages/ParcelOrderDetail';
import AssortQueueList from '@/pages/AssortQueueList';
import AssortQueueListDetail from '@/pages/AssortQueueListDetail';
import AssortDetailList from '@/pages/AssortDetailList';
import GroupQueueList from '@/pages/GroupQueueList';
import GroupQueueListDetail from '@/pages/GroupQueueListDetail';
import GroupDetailList from '@/pages/GroupDetailList';
import DeliveryQueueList from '@/pages/DeliveryQueueList';
import DeliveryQueueListDetail from '@/pages/DeliveryQueueListDetail';
import DeliveryDetailList from '@/pages/DeliveryDetailList';
import DeliveryErrorList from '@/pages/DeliveryErrorList';
import Dsthree from '@/pages/DsThree';
import DsMap from '@/pages/DsHotMap';
import DsPerson from '@/pages/DsPerson';

export default [
  // 包裹订单
  {
    path: '/allocate/parcelOrder/list',
    // component: ParcelOrder,
    component: React.lazy(() => import(/* webpackChunkName: 'ParcelOrder' */ '@/pages/ParcelOrder')),
  },
  {
    path: '/allocate/parcelOrder/detail/:tid',
    // component: ParcelOrderDetail,
    component: React.lazy(() => import(/* webpackChunkName: 'ParcelOrderDetail' */ '@/pages/ParcelOrderDetail')),
  },
  // 分拣
  {
    path: '/allocate/assort/queue/list',
    // component: AssortQueueList,
    component: React.lazy(() => import(/* webpackChunkName: 'AssortQueueList' */ '@/pages/AssortQueueList')),
  },
  {
    path: '/allocate/assort/queue/detail/:tid',
    // component: AssortQueueListDetail,
    component: React.lazy(
      () => import(/* webpackChunkName: 'AssortQueueListDetail' */ '@/pages/AssortQueueListDetail'),
    ),
  },
  {
    path: '/allocate/assort/detailList',
    // component: AssortDetailList,
    component: React.lazy(() => import(/* webpackChunkName: 'AssortDetailList' */ '@/pages/AssortDetailList')),
  },
  // 组包
  {
    path: '/allocate/group/queue/list',
    // component: GroupQueueList,
    component: React.lazy(() => import(/* webpackChunkName: 'GroupQueueList' */ '@/pages/GroupQueueList')),
  },
  {
    path: '/allocate/group/queue/detail/:tid',
    // component: GroupQueueListDetail,
    component: React.lazy(() => import(/* webpackChunkName: 'GroupQueueListDetail' */ '@/pages/GroupQueueListDetail')),
  },
  {
    path: '/allocate/group/detailList',
    // component: GroupDetailList,
    component: React.lazy(() => import(/* webpackChunkName: 'GroupDetailList' */ '@/pages/GroupDetailList')),
  },
  // 发运
  {
    path: '/allocate/delivery/queue/list',
    // component: DeliveryQueueList,
    component: React.lazy(() => import(/* webpackChunkName: 'DeliveryQueueList' */ '@/pages/DeliveryQueueList')),
  },
  {
    path: '/allocate/delivery/queue/detail/:tid',
    // component: DeliveryQueueListDetail,
    component: React.lazy(
      () => import(/* webpackChunkName: 'DeliveryQueueListDetail' */ '@/pages/DeliveryQueueListDetail'),
    ),
  },
  {
    path: '/allocate/delivery/detailList',
    // component: DeliveryDetailList,
    component: React.lazy(() => import(/* webpackChunkName: 'DeliveryDetailList' */ '@/pages/DeliveryDetailList')),
  },
  {
    path: '/allocate/delivery/deliveryAbnor',
    // component: DeliveryErrorList,
    component: React.lazy(() => import(/* webpackChunkName: 'DeliveryErrorList' */ '@/pages/DeliveryErrorList')),
  },
  {
    path: '/service/VideoInquiry',
    // component: Dsthree,
    component: React.lazy(() => import(/* webpackChunkName: 'Dsthree' */ '@/pages/VideoInquiry')),
  },
  {
    path: '/service/addresscore',
    // component: Dsthree,
    component: React.lazy(() => import(/* webpackChunkName: 'Dsthree' */ '@/pages/DsThree')),
  },
  {
    path: '/service/hotmap',
    // component: DsMap,
    component: React.lazy(() => import(/* webpackChunkName: 'Dsthree' */ '@/pages/DsHotMap')),
  },
  {
    path: '/service/dsperson',
    // component: DsPerson,
    component: React.lazy(() => import(/* webpackChunkName: 'Dsthree' */ '@/pages/DsPerson')),
  },
];
